import { classNames } from 'shared/lib/classNames/classNames';
import { useEffect, useState } from 'react';
import { useApi } from 'app/api/APIProvider';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { useBackgrounds } from 'shared/lib/hooks/useBackgrounds/useBackgrounds';
import { Link } from 'react-router-dom';
import Logo from 'shared/assets/icons/logo.svg';
import cls from './LevelLoading.module.scss';
import { useDispatch } from 'react-redux';
import { plotStepData, plotStepsActions } from 'widgets/PlotSteps';

interface LevelLoadingProps {
    characters: string[],
    backgroundKeys: string[],
    stepNumber: number,
    className?: string,
}

export const LevelLoading = ({ characters, backgroundKeys, stepNumber }: LevelLoadingProps) => {
    const api = useApi();
    const dispatch = useDispatch();
    const user = api.User;
    const [progress, setProgress] = useState(0);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const currentStep = user?.current_scene?.plotStep;
    const backgrounds1 = useBackgrounds(backgroundKeys[0]);
    const backgrounds2 = useBackgrounds(backgroundKeys[1]);
    const background1 = backgrounds1.background;
    const background2 = backgrounds2.background;
    const [newBackground, setNewBackground] = useState(background1);
    let plotOptions = {};

    const duration = 5;

    const levelText = {
        1: 'Загрузка первого уровня',
        2: 'Загрузка второго уровня',
        3: 'Загрузка третьего уровня',
        4: 'Загрузка четвертого уровня',
    };

    const changeStep = (stepNumber: number) => {
        api.EditUser({
            current_scene: {
                plotStep: stepNumber,
                previousStep: currentStep,
            },
        }).then(() => {
            user.current_scene = {
                plotStep: stepNumber,
                previousStep: currentStep,
            };
            dispatch(plotStepsActions.addedPlotStepData(plotStepData(stepNumber, user, plotOptions)));
        }).catch((error) => {
            console.log(error);
        });
    };

    const getAllMoney = async () => {
        const money = await api.GetAllSum();
        plotOptions = {
            wallet: money.wallet,
        };
    }

    // useEffect(() => {
    //   const intervalId = setInterval(() => {
    //     if (progress === 50) {
    //         setCurrentImageIndex(currentImageIndex + 1);
    //         setNewBackground(background2);
    //     }
    //     if (progress < 100) {
    //       setProgress((prevProgress) => prevProgress + 1);
    //     }
    //     if (progress === 100) {
    //         changeStep(stepNumber);
    //     }
    //   }, (duration * 1000) / 100);

    //   return () => clearInterval(intervalId);
    // }, [duration, progress]);

    useEffect(() => {
        let changeStepCalled = false;
      
        const intervalId = setInterval(() => {
          if (progress === 50) {
            setCurrentImageIndex(currentImageIndex + 1);
            setNewBackground(background2);
          }
          if (progress < 100) {
            setProgress((prevProgress) => prevProgress + 1);
          }
          if (progress === 100 && !changeStepCalled) {
            changeStepCalled = true;
            changeStep(stepNumber);
          }
        }, (duration * 1000) / 100);
      
        return () => clearInterval(intervalId);
    }, [duration, progress, currentImageIndex, background2, stepNumber]);

    useEffect(() => {
        getAllMoney();
    }, []);

    return (
      <div className={cls.LevelLoading} style={{ backgroundImage: `url('${newBackground}')` }}>
        <div className={cls.logo}>
            <Link to="/" className={cls.logoLink}>
                <Logo />
            </Link>
        </div>
        <div className={cls.imgBox}>
            <img src={characters[0]} alt="" className={classNames(cls.img, { [cls.active]: currentImageIndex === 0 })} />
            <img src={characters[1]} alt="" className={classNames(cls.img, { [cls.active]: currentImageIndex === 1 })} />
        </div>
        <div className={cls.progressBarWrapper}>
            <div className={cls.progressBar}>
                <div
                    className={cls.progress}
                    style={{
                        width: `${progress}%`,
                    }}
                ></div>
            </div>
            <Text className={classNames(cls.progressValue, { [cls.whiteColor]: progress >= 50 })} color="#5B5B5B" size={TextSize.text_16}>{`${Math.round(progress)}%`}</Text>
        </div>
        <Text className={cls.subtext} color="#353850" size={TextSize.text_24}>
            {
                //@ts-ignore
                levelText[user.level]
            }
        </Text>
      </div>
    );
};
